// import AWS from 'aws-sdk';
import { Auth, API } from 'aws-amplify';
import AWS_CONFIG from '@/aws-exports';

import store from '@/store';

// Configuración de valores del ambiente.
// Este archivo NO debe estar ignorado en el repositorio.
import * as EnvVarsUtils from '@/library/utils/env-vars';
import { getGeolocation } from '@/library/utils/geolocation';

// Ejemplo de uso:
// import * as config from '@/config';

if( !!sessionStorage.vessi )	delete sessionStorage.vessi;
if( !!localStorage.vessi )	delete localStorage.vessi;


// URL_API_BOLETAS: url de la api de boletas
export const URL_API_BOLETAS = EnvVarsUtils.getEnvVar('URL_API_BOLETAS');
export const URL_API_HORA = EnvVarsUtils.getEnvVar('URL_API_HORA');

const IdentityPoolId = EnvVarsUtils.getEnvVar('IdentityPoolId');

/////////////////////////////////////
// TODO por remover /////////////////
export const USUARIOS_NOTIFICADORES = EnvVarsUtils.getEnvVar('USUARIOS_NOTIFICADORES');
/////////////////////////////////////

// Formateo números
let numberFormatter = function(x) {
	if(typeof x !== 'number' || !isFinite(x)) {
		throw 'Número a formatear no es número o no es finito';
	}
	let stringifiedNumber = `${x}`;
	let isNegative = (stringifiedNumber[0] === '-');
	let stringifiedNumberWithoutSign = isNegative ? stringifiedNumber.substr(1) : stringifiedNumber;
	let parts = stringifiedNumberWithoutSign.split('.');
	let intPart = parts[0];
	let decPart = parts[1];
	let intPartLength = intPart.length;
	let reversedIntPart = intPart.split('').reverse().join('');
	let reversedNewIntPart = '';
	for(let i=0; i<intPartLength; i++) {
		if((i%3===0) && (i>0)) {
			reversedNewIntPart = reversedNewIntPart + '.';
		}
		reversedNewIntPart = reversedNewIntPart + reversedIntPart[i];
	}
	let newIntPart = reversedNewIntPart.split('').reverse().join('');
	return `${isNegative ? '-' : ''}${newIntPart}` + (decPart === undefined ? '' : `,${decPart}`);
};
let moneyFormatter = function(x) {
	return `$ ${numberFormatter(x)}`;
};

export const FORMATTERS = {
	NUMBER: numberFormatter,
	MONEY: moneyFormatter,
};

export const refreshHandler = async function(err){
  // refresh the token here and get the new token info
  // ......

  const data = {
    token, // the token from the provider
    expires_at, // the timestamp for the expiration
    identity_id // optional, the identityId for the credentials
  };

  return data;
}

/*
const URL_SIGN_IN_CLAVE_UNICA = '';
const CLAVE_UNICA_AMBIENTE = 'claveu.w.sii.cl'
const CLAVE_UNICA_CALLBACK_URL = '-'
const CLAVE_UNICA_CLIENT_ID = 'xxxxxx'
const CLAVE_UNICA_SCOPE = '------'
*/

export const identityProviders = {
	claveUnica: { 
		name: 'clave-unica',
		url: '',
		ambiente: EnvVarsUtils.getEnvVar('CLAVE_UNICA_AMBIENTE'),
		clientId: EnvVarsUtils.getEnvVar('CLAVE_UNICA_CLIENT_ID'),
		callbackUrl: EnvVarsUtils.getEnvVar('CLAVE_UNICA_CALLBACK_URL'),
		scope: EnvVarsUtils.getEnvVar('CLAVE_UNICA_SCOPE'),
		getUrl(){
			return this.url.replace(':AMBIENTE', this.ambiente)
				.replace(':CLIENT_ID', this.clientId)
				.replace(':CALLBACK_URL', this.callbackUrl)
				.replace(':SCOPE', this.scope)
		}
	},
	claveTributaria: {
		name: 'clave-tributaria',
		url: 'https://:AMBIENTE/oauthsii-v1/?response_type=code&client_id=:CLIENT_ID&redirect_uri=:CALLBACK_URL&scope=:SCOPE&state=:STATE',
		ambiente: EnvVarsUtils.getEnvVar('CLAVE_TRIBUTARIA_AMBIENTE'),
		clientId: EnvVarsUtils.getEnvVar('CLAVE_TRIBUTARIA_CLIENT_ID'),
		callbackUrl: EnvVarsUtils.getEnvVar('CLAVE_TRIBUTARIA_CALLBACK_URL'),
		scope: EnvVarsUtils.getEnvVar('CLAVE_TRIBUTARIA_SCOPE'),
		state: EnvVarsUtils.getEnvVar('CLAVE_TRIBUTARIA_STATE'),
		getUrl(){
			return this.url.replace(':AMBIENTE', this.ambiente)
				.replace(':CLIENT_ID', this.clientId)
				.replace(':CALLBACK_URL', this.callbackUrl)
				.replace(':SCOPE', this.scope)
				.replace(':STATE', this.state)
		}
	},
};

export async function signInHandler(query, next){

	if( query == null ){	return;	}
	else if( Object.keys(query).length === 0 ){	return;	}

	const {state, code} = query;

	if( state == null || code == null ){

		let signout = await store.dispatch('usuario/signOut')
		if( !signout )
			next({name: 'inicio'});

	}else{

		const queAuthMethod = (query)=>{
			const {state, code} = query;
			if( state != null || code != null )	return 'clave-tributaria';
		}

		query.authMethod = queAuthMethod(query);

		let signin = await store.dispatch('usuario/signIn', {
			username: '', clave: null, opts: query
		})

		if( signin != null ){
			// if( signin.status != 200 ){
				return !!signin.username;
			}else{
				return false;
			}
		// }
	}

}

export const PLATAFORMA = 'eboleta_web'

export const API_ENVIAR_EMAIL = EnvVarsUtils.getEnvVar('API_ENVIAR_EMAIL');

export const geolocationPlugin = (function(){
	return getGeolocation();
})();

export const API_CODIGO_ESTADOS_DTE = 'https://3j45m2e9r6.execute-api.us-east-1.amazonaws.com/prod/estados'

export const LAMBDA_GET_MENSAJES = 'eboleta_mensajeria-getMensajes'
export const LAMBDA_MARCAR_COMO_LEIDO = 'eboleta_mensajeria-marcarLeido'

export const awsRegion = 'us-east-1'

export const LAMBDA_CONFIG_CONTRIBUYENTE = 'eboleta_getConfigPorContribuyente'

export const AWS_ENV = (()=>AWS_CONFIG.aws_content_delivery_bucket.split('-').pop())()

export const LAMBDA_CONFIG_EMISION = EnvVarsUtils.getEnvVar('LAMBDA_CONFIG_EMISION')

export const LAMBDA_PING = 'eboleta_pingServidor'